@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>{{ level()?.payload?.name }}</h4>
      <small>See details of {{ level()?.payload?.name }}</small>
    </div>

    @if (admins.includes(loggedUserRole ?? '')) {
      <div class="btn-container">
        <button (click)="this.addClass.set(true)" class="button first-button">
          <svg viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M427.84 547.52a193.6 193.6 0 1 0-193.6-193.6 193.92 193.92 0 0 0 193.6 193.6z m0-323.52a129.6 129.6 0 1 1-129.6 129.6A129.92 129.92 0 0 1 427.84 224zM822.72 937.28a32 32 0 0 0-45.44 0 32 32 0 0 0-6.72 10.56A32 32 0 0 0 768 960a32 32 0 1 0 64 0 32 32 0 0 0-2.56-12.16 32 32 0 0 0-6.72-10.56zM672 928h-128a32 32 0 0 0 0 64h128a32 32 0 0 0 0-64z" fill="#fff"></path><path d="M776.96 861.76h2.24a32 32 0 0 0 4.8-3.52l3.84-3.2a32 32 0 0 0 3.84-5.76 20.16 20.16 0 0 0 4.16-10.88 32 32 0 0 0 0-5.76 32 32 0 0 0 0-6.4 30.08 30.08 0 0 0 0-4.8 394.56 394.56 0 0 0-367.36-256A400.64 400.64 0 0 0 32 960a32 32 0 0 0 32 32h352a32 32 0 0 0 0-64H98.56a335.04 335.04 0 0 1 329.28-299.84A330.88 330.88 0 0 1 736 843.52v2.56a32 32 0 0 0 15.04 14.4h1.6a28.48 28.48 0 0 0 23.04 0zM565.76 124.8a110.08 110.08 0 1 1 123.84 179.84 32 32 0 1 0 28.8 57.28 174.08 174.08 0 1 0-196.16-284.16 32 32 0 1 0 43.52 47.04zM675.2 389.44a32 32 0 0 0-6.4 64 293.44 293.44 0 0 1 256 256H832a32 32 0 0 0 0 64h128a32 32 0 0 0 32-32 359.36 359.36 0 0 0-316.8-352z" fill="#fff"></path></g></svg>
          <p>Add a class</p>
        </button>

        <button class="secondary-button" (click)="this.assignSubjectCheck.set(true)">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 10.4V20M12 10.4C12 8.15979 12 7.03969 11.564 6.18404C11.1805 5.43139 10.5686 4.81947 9.81596 4.43597C8.96031 4 7.84021 4 5.6 4H4.6C4.03995 4 3.75992 4 3.54601 4.10899C3.35785 4.20487 3.20487 4.35785 3.10899 4.54601C3 4.75992 3 5.03995 3 5.6V16.4C3 16.9601 3 17.2401 3.10899 17.454C3.20487 17.6422 3.35785 17.7951 3.54601 17.891C3.75992 18 4.03995 18 4.6 18H7.54668C8.08687 18 8.35696 18 8.61814 18.0466C8.84995 18.0879 9.0761 18.1563 9.29191 18.2506C9.53504 18.3567 9.75977 18.5065 10.2092 18.8062L12 20M12 10.4C12 8.15979 12 7.03969 12.436 6.18404C12.8195 5.43139 13.4314 4.81947 14.184 4.43597C15.0397 4 16.1598 4 18.4 4H19.4C19.9601 4 20.2401 4 20.454 4.10899C20.6422 4.20487 20.7951 4.35785 20.891 4.54601C21 4.75992 21 5.03995 21 5.6V16.4C21 16.9601 21 17.2401 20.891 17.454C20.7951 17.6422 20.6422 17.7951 20.454 17.891C20.2401 18 19.9601 18 19.4 18H16.4533C15.9131 18 15.643 18 15.3819 18.0466C15.15 18.0879 14.9239 18.1563 14.7081 18.2506C14.465 18.3567 14.2402 18.5065 13.7908 18.8062L12 20" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
          <p>Assign Subject</p>
        </button>
      </div>
    }
  </section>

  <section class="level-container">
    <div class="box-one">
      <div class="level-details">
        <div class="heading">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_29_115)">
                <path
                  d="M18.3333 8.33341V13.3334M18.3333 8.33341L9.99999 4.16675L1.66666 8.33341L9.99999 12.5001L18.3333 8.33341Z"
                  stroke="white" stroke-width="1.41667" />
                <path d="M5 10V14.1667C7.5 16.6667 12.5 16.6667 15 14.1667V10" stroke="white" stroke-width="1.41667" />
              </g>
              <defs>
                <clipPath id="clip0_29_115">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <small>Level</small>

          <h4>{{ level()?.payload?.name }}</h4>

          <small>{{ level()?.payload?.code }}</small>
        </div>

        <div class="level-numbers">
          <div>
            <h6>{{ dashboardData()?.classes?.total ?? 0 }}</h6>
            <small>Classes</small>
          </div>

          <div class="subject-number">
            <h6>{{ dashboardData()?.subjects?.total ?? 0 }}</h6>
            <small>Subjects</small>
          </div>
        </div>

        @if ((dashboardData()?.classes?.withoutTeacher ?? 0) > 0) {
          <div class="note">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_29_148)">
                <path
                  d="M6.4973 11.9116C9.4876 11.9116 11.9117 9.48748 11.9117 6.49718C11.9117 3.50688 9.4876 1.08276 6.4973 1.08276C3.507 1.08276 1.08289 3.50688 1.08289 6.49718C1.08289 9.48748 3.507 11.9116 6.4973 11.9116Z"
                  stroke="#B45309" stroke-width="1.08288" />
                <path d="M6.49731 4.33154V6.49731" stroke="#B45309" stroke-width="1.08288" />
                <path d="M6.49731 8.66309H6.50273" stroke="#B45309" stroke-width="1.08288" />
              </g>
              <defs>
                <clipPath id="clip0_29_148">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>

              <small>{{ dashboardData()?.classes?.withoutTeacher ?? 0 }} class(es) have no assigned Class Teacher</small>
          </div>
        }
      </div>

      <div class="class-breakdown">
        <h4>Class Breakdown</h4>

        <div class="class-status">
          <div class="status-row">
            <small class="status-name">Active</small>

            <div class="line">
              <div [style.width.%]="percentageOfActiveClasses()" class="active"></div>
            </div>

            <small>{{ dashboardData()?.classes?.active ?? 0 }}</small>
          </div>

          <div class="status-row">
            <small class="status-name">Inactive</small>

            <div class="line">
              <div [style.width.%]="percentageOfInactiveClasses()" class="inactive"></div>
            </div>

            <small>{{ dashboardData()?.classes?.inactive ?? 0 }}</small>
          </div>

          <div class="status-row">
            <small class="status-name">Archived</small>

            <div class="line">
              <div class="archived" [style.width.%]="percentageOfArchivedClasses()"></div>
            </div>

            <small>{{ dashboardData()?.classes?.archived ?? 0 }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="box-two">
      <section class="table-content">

        <div class="class-subject-heading">
          <div class="icon">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_39_211)">
                <path
                  d="M11.9117 5.41448V8.66313M11.9117 5.41448L6.4973 2.70728L1.08288 5.41448L6.4973 8.12169L11.9117 5.41448Z"
                  stroke="#5C0B13" stroke-width="0.974595" />
                <path d="M3.24865 6.49731V9.20452C4.87297 10.8288 8.12162 10.8288 9.74595 9.20452V6.49731"
                      stroke="#5C0B13" stroke-width="0.974595" />
              </g>
              <defs>
                <clipPath id="clip0_39_211">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div>
            <h6>Classes</h6>
            <small>{{ dashboardData()?.classes?.total }} total · {{ dashboardData()?.classes?.active }} active</small>
          </div>

          <div class="filters">
            <select (change)="getClasses('academic_year_id', filterAcademicYear)" [(ngModel)]="filterAcademicYear"
                    name="status" id="status">
              <option value="">Select an academic year</option>

              @for (a of academicYears()?.payload; track a.id) {
                <option [value]="a.id">{{ a.name }}</option>
              }
            </select>
          </div>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
            <tr>
              <th>CLASS ID</th>
              <th>CLASS NAME</th>
              <th>CLASS TEACHER</th>
              <th>STATUS</th>

              @if (admins.includes(loggedUserRole ?? '')) {
                <th class="options-column">ACTIONS</th>
              }
            </tr>
            </thead>

            <tbody>
              @if (isFiltering()) {
                <td colspan="5">
                  <app-loading-indicator />
                </td>
              } @else {
                @if (!classes()?.payload?.length) {
                  <tr>
                    @if (admins.includes(loggedUserRole ?? '')) {
                      <td colspan="5" class="empty">
                        <app-not-found-error>
                          NO CLASSES FOUND
                        </app-not-found-error>
                      </td>
                    } @else {
                      <td colspan="4" class="empty">
                        <app-not-found-error>
                          NO CLASSES FOUND
                        </app-not-found-error>
                      </td>
                    }
                  </tr>
                } @else {
                  @for (u of classes()?.payload; track u.id) {
                    <tr>
                      <td>
                        {{ u.public_id }}
                      </td>

                      <td>
                        {{ u.level_name + u.name }}
                      </td>

                      <td>
                        {{ ((u?.class_teacher_first_name ?? '') + ' ' + (u?.class_teacher_last_name ?? 'None Assigned')) }}
                      </td>

                      <td class="status">
                        <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                      </td>

                      @if (admins.includes(loggedUserRole ?? '')) {
                        <td class="options-column">
                          <app-action-button>
                            <button type="button" class="menu-item" (click)="selectClass(u.id, 'teacher')">Assign Class
                              Teacher
                            </button>

                            <button type="button" class="menu-item" (click)="selectClass(u.id, 'status', u.status)">
                              Change
                              status
                            </button>
                          </app-action-button>
                        </td>
                      }
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>

        <app-pagination
          [page]="classes()?.pagination?.page ?? 0"
          [size]="classes()?.pagination?.size ?? 10"
          [totalElements]="classes()?.pagination?.totalElements ?? 0"
          [totalPages]="classes()?.pagination?.totalPages ?? 0"
          [first]="classes()?.pagination?.first ?? true"
          [last]="classes()?.pagination?.last ?? false"
          [hasNext]="classes()?.pagination?.hasNext ?? false"
          [hasPrevious]="classes()?.pagination?.hasPrevious ?? false"
          (pageChange)="loadPage($event)">
        </app-pagination>

      </section>

      <section class="table-content">

        <div class="class-subject-heading">
          <div class="icon subjects">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_39_396)">
                <path
                  d="M1.08288 1.62427H4.33153C4.90593 1.62427 5.4568 1.85245 5.86296 2.25861C6.26912 2.66477 6.4973 3.21564 6.4973 3.79003V11.3702C6.4973 10.9394 6.32617 10.5263 6.02155 10.2216C5.71693 9.91703 5.30377 9.74589 4.87298 9.74589H1.08288V1.62427Z"
                  stroke="#1D4ED8" stroke-width="0.974595" />
                <path
                  d="M11.9117 1.62427H8.66307C8.08867 1.62427 7.5378 1.85245 7.13164 2.25861C6.72548 2.66477 6.4973 3.21564 6.4973 3.79003V11.3702C6.4973 10.9394 6.66843 10.5263 6.97305 10.2216C7.27767 9.91703 7.69083 9.74589 8.12162 9.74589H11.9117V1.62427Z"
                  stroke="#1D4ED8" stroke-width="0.974595" />
              </g>
              <defs>
                <clipPath id="clip0_39_396">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div>
            <h6>Subjects</h6>
            <small>{{ dashboardData()?.subjects?.total }} total · {{ dashboardData()?.subjects?.active }} active</small>
          </div>
        </div>

        <div class="table-wrapper subject-table">
          <table>
            <thead>
            <tr>
              <th>SUBJECT CODE</th>
              <th>SUBJECT NAME</th>
              <th>DATE CREATED</th>
              <th>STATUS</th>

              @if (admins.includes(loggedUserRole ?? '')) {
                <th class="options-column">ACTIONS</th>
              }
            </tr>
            </thead>

            <tbody>
              @if (isFiltering()) {
                <td colspan="5">
                  <app-loading-indicator />
                </td>
              } @else {
                @if (!levelSubjects()?.payload?.length) {

                  <tr>
                    @if (admins.includes(loggedUserRole ?? '')) {
                      <td colspan="5" class="empty">
                        <app-not-found-error>
                          NO SUBJECTS AVAILABLE FOR THIS LEVEL
                        </app-not-found-error>
                      </td>
                    } @else {
                      <td colspan="4" class="empty">
                        <app-not-found-error>
                          NO SUBJECTS AVAILABLE FOR THIS LEVEL
                        </app-not-found-error>
                      </td>
                    }
                  </tr>
                } @else {
                  @for (u of levelSubjects()?.payload; track u.id) {
                    <tr>
                      <td>
                        {{ u.subject_code }}
                      </td>

                      <td>
                        {{ u.subject_name }}
                      </td>

                      <td>
                        {{ Helpers.formatDate(u.created_at) }}
                      </td>

                      <td class="status">
                        <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                      </td>

                      @if (admins.includes(loggedUserRole ?? '')) {
                        <td class="options-column">
                          <app-action-button>
                            <button class="menu-item" (click)="setAssignSubjectTeacher(u)">Assign Subject Teacher
                            </button>
                            <button class="menu-item" (click)="selectClass(u.id, 'subjectStatus', u.status)">Change
                              status
                            </button>
                          </app-action-button>
                        </td>
                      }
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>

        <app-pagination
          [page]="levelSubjects()?.pagination?.page ?? 0"
          [size]="levelSubjects()?.pagination?.size ?? 10"
          [totalElements]="levelSubjects()?.pagination?.totalElements ?? 0"
          [totalPages]="levelSubjects()?.pagination?.totalPages ?? 0"
          [first]="levelSubjects()?.pagination?.first ?? true"
          [last]="levelSubjects()?.pagination?.last ?? false"
          [hasNext]="levelSubjects()?.pagination?.hasNext ?? false"
          [hasPrevious]="levelSubjects()?.pagination?.hasPrevious ?? false"
          (pageChange)="loadSubjectPage($event)">
        </app-pagination>

      </section>
    </div>
  </section>
}


@if (addClass()) {
  <section class="pop-up">
    <div class="bg" (click)="addClass.set(false)"></div>

    <form #newClassForm="ngForm" (ngSubmit)="createClass(newClassForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Add a Class</h6>
          <small>Classes are subsets of a level</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select required [(ngModel)]="academicYearId" name="academicYearId" id="academicYearId">
            <option value="">Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              @if (!invalidStatuses.includes(a.status)) {
                <option [value]="a.id">{{ a.name }}</option>
              }
            }
          </select>
        </div>

        @if (academicYearId && academicYearId !== '') {
          <div>
          <label for="nameOfClass">Name of class <span class="required-check">*</span></label>

          <select required [(ngModel)]="nameOfClass" name="nameOfClass" id="nameOfClass">
            <option value="">Select a class name</option>

            @for (c of classList; track c) {
              @if (!classExists(c)) {
                <option [value]="c">{{ c }}</option>
              }
            }
          </select>
        </div>
        }
        <div class="teachers-box">
          <label for="query">Search Class Teacher</label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>

              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                  <h6>{{
                      Helpers.fullName({
                        first_name: t.first_name,
                        last_name: t.last_name,
                      })
                    }}
                  </h6>
                  <p>Teacher ID: {{ t.public_id }}</p>
                </li>
                }
              }

            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="teacher-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>

            <div class="teacher-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>

              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }


        <div>
          <label for="capacity">Class Capacity</label>
          <input [(ngModel)]="capacity" type="number" name="capacity" id="capacity" placeholder="50">
        </div>

        <button [disabled]="newClassForm.invalid" class="secondary-button" type="submit">
          @if (isCreatingClass()) {
            <app-loading-indicator />
          } @else {
            Add Class
          }
        </button>

      </div>
    </form>
  </section>
}

@if (assignSubjectTeacherCheck()) {
  <section class="pop-up">
    <div class="bg" (click)="assignSubjectTeacherCheck.set(false)"></div>

    <form #newSubjectTeacherForm="ngForm" (ngSubmit)="assignSubjectTeacher(newSubjectTeacherForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign {{ selectedLevelSubject.subject_name }} to a Teacher</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="nameOfClass">Name of class <span class="required-check">*</span></label>
          <select required [(ngModel)]="nameOfClass" name="nameOfClass" id="nameOfClass">
            <option value="">Select a class name</option>

            @for (c of classes()?.payload; track $index) {
              <option [value]="c.id">{{ level()?.payload?.name + c.name }}</option>
            }
          </select>
        </div>

        <div class="teachers-box">
          <label for="query">Search Class Teacher <span class="required-check">*</span></label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>

              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                  <h6>{{
                      Helpers.fullName({
                        first_name: t.first_name,
                        last_name: t.last_name,
                      })
                    }}
                  </h6>
                  <p>Teacher ID: {{ t.public_id }}</p>
                </li>
                }
              }

            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="teacher-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>

            <div class="teacher-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>

              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }


        <div>
          <label for="assignmentRole">Teacher Role <span class="required-check">*</span></label>
          <select required [(ngModel)]="assignmentRole" name="assignmentRole" id="assignmentRole">
            <option value="">Select a role</option>
            <option value="LEAD">Lead</option>
            <option value="ASSISTANT">Assistant</option>
            <option value="SUBSTITUTE">Substitute</option>
          </select>
        </div>

        <button [disabled]="newSubjectTeacherForm.invalid" class="button" type="submit">
          @if (isAssigningSubjectTeacher()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Assign Teacher
          }
        </button>

      </div>
    </form>
  </section>
}

@if (assignSubjectCheck()) {
  <section class="pop-up">
    <div class="bg" (click)="assignSubjectCheck.set(false)"></div>

    <form #newSubjectForm="ngForm" (ngSubmit)="assignSubject(newSubjectForm)">
      <!--      @if (allSubjectsIncluded()) {-->
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign a Subject to {{ level()?.payload?.name }}</h6>
          <small>All classes under {{ level()?.payload?.name }} will automatically be enrolled.</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="subjectId">Name of Subject <span class="required-check">*</span></label>
          <select required [(ngModel)]="subjectId" name="subjectId" id="subjectId">
            <option value="">Select a subject</option>

            @for (s of subjectList()?.payload; track s.id) {

              @if (!levelSubjects()?.payload?.some(subject => subject.subject_id === s.id)) {
                <option [value]="s.id">{{ s.name }}</option>
              }
            }
          </select>
        </div>

        <button [disabled]="newSubjectForm.invalid" class="secondary-button" type="submit">
          @if (isAssigningSubjectTeacher()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Assign Subject
          }
        </button>

      </div>

      <!--      } @else {-->
      <!--        <h6>All Subjects have been assigned to this level.</h6>-->
      <!--      }-->
    </form>

  </section>
}

@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="changeClassStatus(changeStatusForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path> <path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path> <path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path> <path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Select a new status</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="newStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== currentStatus) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>

        </div>

        <button class="button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>

    </form>
  </section>
}

@if (assignClassTeacher()) {
  <section class="pop-up">
    <div class="bg" (click)="assignClassTeacher.set(false)"></div>

    <form #classTeacherForm="ngForm" (ngSubmit)="assignClassTeacherFn(classTeacherForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign class to a Teacher</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div class="teachers-box">
          <label for="query">Search Class Teacher <span class="required-check">*</span></label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>

              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                  <h6>{{
                      Helpers.fullName({
                        first_name: t.first_name,
                        last_name: t.last_name,
                      })
                    }}
                  </h6>
                  <p>Teacher ID: {{ t.public_id }}</p>
                </li>
                }
              }

            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="teacher-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>

            <div class="teacher-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>

              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }

        <button [disabled]="classTeacherForm.invalid || !classTeacherId" class="button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Assign Class Teacher
          }
        </button>

      </div>

    </form>
  </section>
}

@if (changeSubjectStatusCheck()) {
  <section class="pop-up">
    <div class="bg" (click)="changeSubjectStatusCheck.set(false)"></div>

    <form #changeSubjectStatusForm="ngForm" (ngSubmit)="changeSubjectStatus(changeSubjectStatusForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path> <path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path> <path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path> <path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
        </div>
        <div>
          <h6>Change Subject Status for {{ level()?.payload?.name }}</h6>
          <small>Select a new status</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="newSubjectStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newSubjectStatus" name="newSubjectStatus" id="newSubjectStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== currentSubjectStatus) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>

        </div>

        <button class="button" [disabled]="changeSubjectStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>

    </form>
  </section>
}






